import "../Css/home.css"
export default function Testomonials({para , img , title , disc}) {
  return (
    <div className="Testomonials">
      <p>{para}</p>
      <div className="testo-img">
        <img src={img} alt="TESTO - IMG" />
        <div className="testo-text">
            <h5>{title}</h5>
            <span>{disc}</span>
        </div>
      </div>
    </div>
  );
}
